// APP_VERSION is forwarded from package.json via the `start`/`build` npm scripts
// (APP_VERSION=$npm_package_version). Parcel inlines this at build time, but it
// strips npm_*-prefixed vars from the bundle, so the npm_package_version env var
// cannot be referenced here directly — it would always resolve to undefined.
export const APP_VERSION = process.env['APP_VERSION'] ?? '0.0.0';
